import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React from 'react';
import { convertToCurrencyString } from '../../../utils/currencyUtil';

interface BuyerRegistration {
  id: number;
  name: string;
  phoneNumber: string;
  amount: number;
  status: string;
}

const BuyerRegistrationPayments: React.FC = () => {
  const columns: ColumnsType<BuyerRegistration> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Phone Number',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      render: (amount: number) => `${convertToCurrencyString(amount)}`,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
  ];

  const buyers: readonly any[] | undefined = [];

  return <Table dataSource={buyers} columns={columns} rowKey='id' size='small' />;
};

export default BuyerRegistrationPayments;
